import { headerAction } from './modules/headerAction';
import { scrollMagic } from './modules/scrollMagic';
import { smooth } from './modules/smooth';
import { windowAction } from './modules/windowAction';
headerAction();
smooth();
windowAction();
scrollMagic();
